import { render, staticRenderFns } from "./TableControls.component.vue?vue&type=template&id=7284272a"
import script from "./TableControls.component.vue?vue&type=script&lang=js"
export * from "./TableControls.component.vue?vue&type=script&lang=js"
import style0 from "./TableControls.component.vue?vue&type=style&index=0&id=7284272a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports